<template>
    <div style="padding-top: 1rem;">
        <comment 
            v-for="(comment, i) in comments" 
            :key="i" 
            :comment="comment"
            @destroyed="commentDeleted(comment)"
        ></comment>
        <new-comment-controls
            ref="newCommentControls"
            @save="saveComment" 
            :is-loading="isLoading"
            :style="comments.length > 0 ? 'padding-top: 2rem;' : ''"
        ></new-comment-controls>
    </div>
</template>

<script>
    import Comment from './Comment'
    import NewCommentControls from './NewCommentControls'
    import { CommentResource } from '../../classes/Api/Comment'

    export default {
        components: { 
            Comment,
            NewCommentControls
        },
        props: {
            autoLoad: {
                type: Boolean,
                default: true
            },
            ownerType: {
                type: String,
                required: true
            },
            ownerId: {
                type: [String,Number],
                required: true,
            }
        },
        created() {
            if (this.autoLoad) {
                this.loadComments();
            }
        },
        data() {
            return {
                isLoading: true,
                comments: []
            }
        },
        watch: {
            ownerType(n, o) {
                if (n !== o && this.autoLoad) {
                    this.loadComments();
                }
            },
            ownerId(n, o) {
                if (n !== o && this.autoLoad) {
                    this.loadComments();
                }
            },
        },
        methods: {
            loadComments() {
                return new Promise((resolve, reject) => {
                    this.isLoading = true;

                    CommentResource.all({ owner: this.ownerType + ':' + this.ownerId }).then(response => {
                        this.comments = response.data;
                        this.isLoading = false;
                        resolve();
                    }, e => { this.isLoading = false; handleApiError(e); reject(); });
                })
            },
            saveComment(content) {
                this.isLoading = true;
                
                CommentResource.store({ content }, { owner: this.ownerType + ':' + this.ownerId}).then(response => {
                    this.comments.push(response.data);
                    this.isLoading = false;
                    this.$refs.newCommentControls.reset();
                    this.$emit('saved', response.data)
                }, e => { this.isLoading = false; handleApiError(e) });
            },
            commentDeleted(comment) {
                this.comments = this.comments.filter(item => comment.id !== item.id);
            }
        }
    }
</script>